import { Link, useLocation, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { useVideo } from "../contexts/VideoContext";

import femmeImg from "../assets/femme.jpg";
import hommeImg from "../assets/homme.jpg";
import enfantImg from "../assets/enfant.jpg";
import collectionsImg from "../assets/collections.jpg";
import pretVideo from "../assets/video/pret.mp4";
import Footer from "../components/Footer";
import PopularProducts from "../components/Products/PopularProducts";
import VideoControls from "../components/VideoControls";

export default function Home() {
  const location = useLocation();
  const navigate = useNavigate();
  const { isMuted, isPaused, toggleSound, togglePause, setVideoElement } = useVideo();
  const [showWhatsApp, setShowWhatsApp] = useState(false);
  const [showOrderSuccess, setShowOrderSuccess] = useState(!!location.state?.orderSuccess);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 30) {
        setShowWhatsApp(true);
      } else {
        setShowWhatsApp(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (location.state?.orderSuccess) {
      setShowOrderSuccess(true);
      // Nettoyer l'état pour éviter la réouverture au refresh/back
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location, navigate]);

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600;700;800;900&family=Cormorant+Garamond:wght@300;400;500;600;700&family=Inter:wght@300;400;500;600;700&display=swap');
        
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        body {
          margin: 0;
          padding: 0;
          overflow-x: hidden;
          font-family: 'Cormorant Garamond', serif;
          background: linear-gradient(135deg, #f8f5f0 0%, #f0ebe0 100%);
        }

        * {
          font-family: 'Cormorant Garamond', serif;
        }

        .section-title {
          text-align: center;
          font-size: 2.5rem;
          font-weight: 700;
          margin-bottom: 40px;
          color: #2c1810;
          font-family: 'Cormorant Garamond', serif;
          letter-spacing: 1px;
        }

        .section-containers {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
          gap: 30px;
          padding: 40px 20px;
          max-width: 1200px;
          margin: 0 auto;
          background: rgba(255, 255, 255, 0.05);
          backdrop-filter: blur(20px);
          border: 1px solid rgba(212, 175, 55, 0.1);
          border-radius: 20px;
        }

        .best-sellers-container {
          background: rgba(255, 255, 255, 0.05);
          backdrop-filter: blur(20px);
          padding: 60px 20px;
          margin: 100px 0;
          border-radius: 20px;
          position: relative;
          overflow: hidden;
          border: 1px solid rgba(212, 175, 55, 0.1);
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
        }

        .section-title {
          text-align: center;
          font-size: 2rem;
          font-weight: 600;
          margin-bottom: 40px;
          color: #2c1810;
          font-family: 'Cormorant Garamond', serif;
          position: relative;
          z-index: 2;
        }

        .section-title::after {
          content: '';
          position: absolute;
          bottom: -10px;
          left: 50%;
          transform: translateX(-50%);
          width: 80px;
          height: 2px;
          background: #d4af37;
          border-radius: 1px;
        }

        .section-containers {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
          gap: 30px;
          padding: 40px 20px;
          max-width: 1200px;
          margin: 0 auto;
          position: relative;
          z-index: 2;
          background: rgba(255, 255, 255, 0.05);
          backdrop-filter: blur(20px);
          border: 1px solid rgba(212, 175, 55, 0.1);
          border-radius: 20px;
        }

        .best-sellers-section {
          position: relative;
          z-index: 2;
        }

        .best-sellers-decoration {
          position: absolute;
          top: 30px;
          left: 30px;
          width: 40px;
          height: 40px;
          background: rgba(212, 175, 55, 0.2);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #d4af37;
          font-size: 1.2rem;
          box-shadow: 0 4px 16px rgba(212, 175, 55, 0.1);
          z-index: 3;
          border: 1px solid rgba(212, 175, 55, 0.2);
        }

        .best-sellers-decoration:nth-child(2) {
          top: auto;
          bottom: 30px;
          right: 30px;
          left: auto;
        }

        .best-sellers-decoration:nth-child(3) {
          top: 50%;
          left: 20px;
          transform: translateY(-50%);
          width: 30px;
          height: 30px;
          font-size: 1rem;
        }

        .best-sellers-decoration:nth-child(4) {
          top: 50%;
          right: 20px;
          left: auto;
          transform: translateY(-50%);
          width: 30px;
          height: 30px;
          font-size: 1rem;
        }

        .home-header {
          height: 100vh;
          width: 100vw;
          color: white;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          text-align: center;
          position: relative;
          padding: 0;
          margin: 0;
          overflow: hidden;
          left: 50%;
          transform: translateX(-50%);
        }

        .hero-video {
          position: absolute;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          object-fit: cover;
          z-index: 0;
          margin: 0;
          padding: 0;
          min-width: 100%;
          min-height: 100%;
        }

        .hero-overlay {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          z-index: 2;
          background: rgba(0, 0, 0, 0.3);
          padding: 40px;
          border-radius: 15px;
          backdrop-filter: blur(10px);
          margin: 0;
          opacity: 0;
          animation: fadeInText 1s ease-in-out 3s forwards;
        }



        @keyframes fadeInText {
          0% {
            opacity: 0;
            transform: translate(-50%, -50%) scale(0.9);
          }
          100% {
            opacity: 1;
            transform: translate(-50%, -50%) scale(1);
          }
        }

        .hero-overlay h1 {
          font-size: 80px;
          font-weight: 800;
          margin-bottom: 15px;
          text-shadow: 2px 2px 8px rgba(0,0,0,0.7);
          opacity: 0;
          animation: slideInTitle 1s ease-out 3.5s forwards;
          font-family: 'Cormorant Garamond', serif;
          letter-spacing: 2px;
        }

        .hero-overlay p {
          font-size: 20px;
          font-style: italic;
          letter-spacing: 1px;
          text-shadow: 1px 1px 4px rgba(0,0,0,0.6);
          opacity: 0;
          animation: slideInSubtitle 1s ease-out 4s forwards;
          font-family: 'Cormorant Garamond', serif;
        }

        @keyframes slideInTitle {
          0% {
            opacity: 0;
            transform: translateY(20px);
          }
          100% {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes slideInSubtitle {
          0% {
            opacity: 0;
            transform: translateY(15px);
          }
          100% {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .container-card {
          position: relative;
          width: 100%;
          height: 400px;
          border-radius: 20px;
          overflow: hidden;
          text-decoration: none;
          color: white;
          background: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(20px);
          border: 1px solid rgba(212, 175, 55, 0.2);
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .container-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
        }

        .container-card img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.3s ease;
        }

        .container-card:hover img {
          transform: scale(1.05);
        }

        .container-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.3);
          backdrop-filter: blur(3px);
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 30px;
          text-align: center;
        }

         .container-overlay2 {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.3);
          backdrop-filter: blur(1px);
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 30px;
          text-align: center;
        }

        .container-overlay h3 {
          font-size: 24px;
          font-weight: 600;
          margin-bottom: 15px;
          font-family: 'Cormorant Garamond', serif;
        }

        .container-overlay p {
          font-size: 14px;
          margin-bottom: 25px;
          font-family: 'Cormorant Garamond', serif;
          line-height: 1.5;
        }

        .container-overlay button {
          background: rgba(255, 255, 255, 0.9);
          color: #2c1810;
          font-weight: 600;
          padding: 10px 20px;
          border-radius: 15px;
          border: 1px solid rgba(212, 175, 55, 0.2);
          cursor: pointer;
          font-size: 13px;
          transition: all 0.3s ease;
          font-family: 'Cormorant Garamond', serif;
          text-transform: uppercase;
          backdrop-filter: blur(10px);
        }

        .container-overlay button:hover {
          background: rgba(255, 255, 255, 1);
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }

        .collections-speciales-section {
          background: rgba(255, 255, 255, 0.05);
          backdrop-filter: blur(20px);
          border-top: 1px solid rgba(212, 175, 55, 0.1);
          border-bottom: 1px solid rgba(212, 175, 55, 0.1);
          padding: 40px 20px;
          margin: 60px 0;
          position: relative;
        }

        .collections-speciales-container {
          max-width: 1200px;
          margin: 0 auto;
        }

        .collections-speciales-card {
          position: relative;
          width: 100%;
          height: 400px;
          border-radius: 20px;
          overflow: hidden;
          text-decoration: none;
          color: white;
          background: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(20px);
          border: 1px solid rgba(212, 175, 55, 0.2);
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
          cursor: pointer;
          transition: all 0.3s ease;
          display: block;
        }

        .collections-speciales-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
        }

        .collections-speciales-card img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.3s ease;
        }

        .collections-speciales-card:hover img {
          transform: scale(1.05);
        }

        .collections-speciales-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.3);
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 30px;
        }

        .collections-speciales-content {
          text-align: center;
          max-width: 500px;
          background: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.2);
          border-radius: 15px;
          padding: 30px;
        }

        .collections-speciales-content h3 {
          font-size: 2rem;
          font-weight: 600;
          margin-bottom: 15px;
          font-family: 'Cormorant Garamond', serif;
        }

        .collections-speciales-content p {
          font-size: 1rem;
          margin-bottom: 25px;
          font-family: 'Cormorant Garamond', serif;
          line-height: 1.5;
        }

        .collections-speciales-content button {
          background: rgba(212, 175, 55, 0.2);
          color: #2c1810;
          font-weight: 600;
          padding: 12px 25px;
          border-radius: 15px;
          border: 1px solid rgba(212, 175, 55, 0.3);
          cursor: pointer;
          font-size: 14px;
          transition: all 0.3s ease;
          font-family: 'Cormorant Garamond', serif;
          text-transform: uppercase;
        }

        .collections-speciales-content button:hover {
          background: rgba(212, 175, 55, 0.3);
          transform: translateY(-2px);
        }

        @media (max-width: 768px) {
          .collections-speciales-card {
            height: 350px;
          }

          .collections-speciales-content {
            padding: 25px;
          }

          .collections-speciales-content h3 {
            font-size: 1.8rem;
          }

          .collections-speciales-content p {
            font-size: 0.9rem;
          }

          .collections-speciales-content button {
            padding: 10px 20px;
            font-size: 13px;
          }
        }

        .why-choose-section {
          background: rgba(255, 255, 255, 0.05);
          backdrop-filter: blur(20px);
          border-top: 1px solid rgba(212, 175, 55, 0.1);
          border-bottom: 1px solid rgba(212, 175, 55, 0.1);
          padding: 20px 20px;
          text-align: center;
          margin: 100px 0;
          position: relative;
          overflow: hidden;
        }

        .why-choose-title {
          font-size: 2rem;
          font-weight: 600;
          margin-bottom: 50px;
          color: #2c1810;
          font-family: 'Cormorant Garamond', serif;
          position: relative;
        }

        .why-choose-title::after {
          content: '';
          position: absolute;
          bottom: -10px;
          left: 50%;
          transform: translateX(-50%);
          width: 80px;
          height: 2px;
          background: #d4af37;
          border-radius: 1px;
        }

        .why-choose-title span {
          color: #d4af37;
          font-weight: 600;
        }

        .why-choose-cards {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
          gap: 30px;
          margin: 0 auto;
          max-width: 1200px;
        }

        .why-card {
          background: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(20px);
          border: 1px solid rgba(212, 175, 55, 0.2);
          padding: 30px;
          border-radius: 20px;
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
          transition: all 0.3s ease;
          text-align: center;
          position: relative;
        }

        .why-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
        }

        .why-card-icon {
          width: 48px;
          height: 48px;
          margin: 0 auto 20px;
          color: #d4af37;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.3s ease;
        }

        .why-card:hover .why-card-icon {
          transform: scale(1.05);
        }

        .why-card-icon svg {
          width: 48px;
          height: 48px;
          color: #d4af37;
          transition: all 0.3s ease;
        }

        .why-card h4 {
          font-size: 18px;
          font-weight: 600;
          margin-bottom: 15px;
          color: #2c1810;
          font-family: 'Cormorant Garamond', serif;
        }

        .why-card p {
          font-size: 14px;
          color: #5a4a3a;
          line-height: 1.6;
          font-family: 'Cormorant Garamond', serif;
        }

        .why-card-number {
          position: absolute;
          top: -15px;
          left: 50%;
          transform: translateX(-50%);
          width: 30px;
          height: 30px;
          background: #d4af37;
          color: #2c1810;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          font-weight: 600;
          font-family: 'Cormorant Garamond', serif;
        }

        .whatsapp-float {
          position: fixed;
          bottom: 25px;
          left: 25px;
          z-index: 1000;
          width: 60px;
          height: 60px;
          background: #25d366;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
          transition: all 0.3s ease;
          animation: slideInWhatsApp 0.5s ease-out;
        }

        @keyframes slideInWhatsApp {
          from {
            opacity: 0;
            transform: translateX(-100px) scale(0.8);
          }
          to {
            opacity: 1;
            transform: translateX(0) scale(1);
          }
        }

        .whatsapp-float:hover {
          transform: scale(1.1);
        }

        .whatsapp-float img {
          width: 35px;
          height: 35px;
        }

        .features-section {
          backdrop-filter: blur(20px);
          border-top: 1px solid rgba(34, 139, 34, 0.2);
          border-bottom: 1px solid rgba(34, 139, 34, 0.2);
          padding: 60px 20px;
          margin: 80px 0;
          position: relative;
          overflow: hidden;
        }

        .features-container {
          max-width: 1200px;
          margin: 0 auto;
        }

        .features-title {
          text-align: center;
          font-size: 2.5rem;
          font-weight: 700;
          margin-bottom: 50px;
          color: #2c1810;
          font-family: 'Cormorant Garamond', serif;
          position: relative;
        }

        .features-title::after {
          content: '';
          position: absolute;
          bottom: -15px;
          left: 50%;
          transform: translateX(-50%);
          width: 100px;
          height: 3px;
          background: linear-gradient(90deg, #228b22, #32cd32);
          border-radius: 2px;
        }

        .features-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 30px;
          margin-top: 40px;
        }

        .feature-card {
          background: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(20px);
          border: 1px solid rgba(34, 139, 34, 0.3);
          border-radius: 20px;
          padding: 30px 25px;
          text-align: center;
          transition: all 0.3s ease;
          position: relative;
          overflow: hidden;
          box-shadow: 0 8px 32px rgba(34, 139, 34, 0.1);
        }

        .feature-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(135deg, rgba(34, 139, 34, 0.05) 0%, rgba(50, 205, 50, 0.02) 100%);
          opacity: 0;
          transition: opacity 0.3s ease;
        }

        .feature-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 12px 40px rgba(34, 139, 34, 0.2);
          border-color: rgba(34, 139, 34, 0.5);
          background: whitesmoke;
          cursor: pointer;
          border:none;
        }

        .feature-card:hover::before {
          opacity: 1;
        }

        .feature-icon {
          width: 60px;
          height: 60px;
          margin: 0 auto 20px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 2px solid #4B3B1A;
          position: relative;
          z-index: 2;
        }

        .feature-icon svg {
          width: 30px;
          height: 30px;
          color:#4B3B1A;
        }

        .feature-title {
          font-size: 1.2rem;
          font-weight: 600;
          margin-bottom: 10px;
          color: #2c1810;
          font-family: 'Cormorant Garamond', serif;
          position: relative;
          z-index: 2;
        }

        .feature-subtitle {
          font-size: 0.9rem;
          color: #5a4a3a;
          font-family: 'Cormorant Garamond', serif;
          font-style: italic;
          position: relative;
          z-index: 2;
        }

        .feature-description {
          font-size: 0.85rem;
          color: #666;
          margin-top: 8px;
          font-family: 'Cormorant Garamond', serif;
          position: relative;
          z-index: 2;
        }

        @media (max-width: 768px) {
          .features-title {
            font-size: 2rem;
          }

          .features-grid {
            grid-template-columns: 1fr;
            gap: 25px;
          }

          .feature-card {
            padding: 25px 20px;
          }

          .feature-icon {
            width: 50px;
            height: 50px;
          }

          .feature-icon svg {
            width: 25px;
            height: 25px;
          }
        }

                  @media (max-width: 768px) {
            .hero-overlay h1 {
              font-size: 60px;
            }

            .hero-overlay {
              padding: 30px;
            }

            .sound-control {
              top: 70px;
              right: 20px;
              width: 45px;
              height: 45px;
            }

            .sound-control svg {
              width: 18px;
              height: 18px;
            }

            .pause-control {
              top: 130px;
              right: 20px;
              width: 45px;
              height: 45px;
            }

            .pause-control svg {
              width: 18px;
              height: 18px;
            }

            .why-choose-title {
              font-size: 2.2rem;
              margin-bottom: 60px;
            }

            .why-choose-cards {
              grid-template-columns: 1fr;
              gap: 30px;
            }

            .why-card {
              padding: 40px 25px;
            }

            .why-card-icon {
              width: 70px;
              height: 70px;
            }

            .why-card-icon svg {
              width: 35px;
              height: 35px;
            }

            .section-title {
              font-size: 2.5rem;
            }

            .best-sellers-decoration {
              display: none;
            }

            .best-sellers-container {
              padding: 60px 0;
              margin: 80px 0;
            }
          }

                  @media (max-width: 480px) {
            .hero-overlay h1 {
              font-size: 48px;
            }

            .hero-overlay p {
              font-size: 24px;
            }

            .hero-overlay {
              padding: 25px;
            }



            .container-overlay h3 {
              font-size: 24px;
            }

            .why-choose-title {
              font-size: 1.8rem;
            }

            .section-title {
              font-size: 2rem;
            }

            .best-sellers-container {
              padding: 50px 0;
              margin: 60px 0;
              border-radius: 20px;
            }

            .best-sellers-container::after {
              top: 10px;
              left: 10px;
              right: 10px;
              bottom: 10px;
              border-radius: 15px;
            }
          }
      `}</style>

      <main>
        {showOrderSuccess && (
          <div
            style={{
              position: "fixed",
              inset: 0,
              background: "rgba(0,0,0,0.45)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 2000,
            }}
            onClick={() => setShowOrderSuccess(false)}
          >
            <div
              onClick={(e) => e.stopPropagation()}
              style={{
                width: "90%",
                maxWidth: 520,
                background: "#fff",
                borderRadius: 12,
                padding: 24,
                boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
                textAlign: "center",
                fontFamily: "'Cormorant Garamond', serif",
                color: "#2c1810",
              }}
            >
              <h3 style={{ marginTop: 0, marginBottom: 10 }}>Commande effectuée avec succès</h3>
              <p style={{ margin: 0, marginBottom: 16 }}>
                Un agent vous contactera sous peu.
              </p>
              <button
                onClick={() => setShowOrderSuccess(false)}
                style={{
                  padding: "10px 16px",
                  borderRadius: 8,
                  border: "1px solid #d4af37",
                  background: "rgba(212,175,55,0.15)",
                  cursor: "pointer",
                  fontWeight: 600,
                }}
              >
                Fermer
              </button>
            </div>
          </div>
        )}
        <section className="home-header">
          <video
            ref={setVideoElement}
            className="hero-video"
            autoPlay
            loop
            muted={isMuted}
            playsInline
          >
            <source src={pretVideo} type="video/mp4" />
            Votre navigateur ne supporte pas la lecture de vidéos.
          </video>


          
          <div className="hero-overlay" style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column'
          }}>
            <h1>SAFA</h1>
            <p>La tradition marocaine à vos pieds, élégance et confort</p>
          </div>
        </section>

        <section className="section-containers">
          <Link to="/products/femme" className="container-card">
            <img src={femmeImg} alt="Femme" />
            <div className="container-overlay">
              <h3>FEMME</h3>
              <p>Découvrez notre collection élégante pour femme</p>
              <button>Découvrir la sélection</button>
            </div>
          </Link>

          <Link to="/products/homme" className="container-card">
            <img src={hommeImg} alt="Homme" />
            <div className="container-overlay">
              <h3>HOMME</h3>
              <p>Confort et style pour homme, à la marocaine</p>
              <button>Découvrir la sélection</button>
            </div>
          </Link>

          <Link to="/products/enfant" className="container-card">
            <img src={enfantImg} alt="Enfant" />
            <div className="container-overlay">
              <h3>ENFANT</h3>
              <p>Des modèles ludiques et confortables pour les plus jeunes</p>
              <button>Découvrir la sélection</button>
            </div>
          </Link>
        </section>

        <section className="why-choose-section">
          <h2 className="why-choose-title">
            Pourquoi choisir <span>SAFA Store</span> ?
          </h2>
          <div className="why-choose-cards">
            {[
              {
                title: "Livraison gratuite",
                desc: "Profitez de la livraison gratuite. Expédition rapide sous 48h au Maroc.",
              },
              {
                title: "Service client premium",
                desc: "Notre équipe est disponible par WhatsApp ou e-mail pour répondre rapidement à vos besoins.",
              },
              {
                title: "Savoir-faire artisanal",
                desc: "Des babouches conçues à la main avec des matériaux naturels pour un confort inégalé.",
              },
            ].map((item, index) => (
              <div className="why-card" key={index}>
                <div className="why-card-number">{index + 1}</div>
                <div className="why-card-icon">
                  {index === 0 && (
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h4c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-5.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z" />
                      <path
                        d="M12 2L2 7l10 5 9-4.5V21h-2V12.5L12 17l-9-4.5V2H2V7l10 5z"
                        opacity="0.3"
                      />
                    </svg>
                  )}
                  {index === 1 && (
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                      <circle
                        cx="12"
                        cy="12"
                        r="10"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        opacity="0.3"
                      />
                    </svg>
                  )}
                  {index === 2 && (
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                      <circle
                        cx="12"
                        cy="12"
                        r="10"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1"
                        opacity="0.2"
                      />
                    </svg>
                  )}
                </div>
                <h4>{item.title}</h4>
                <p>{item.desc}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="collections-speciales-section">
          <div className="collections-speciales-container">
            <Link
              to="/products/collections-speciales"
              className="collections-speciales-card"
            >
              <img src={collectionsImg} alt="Collections Spéciales" />
              <div className="collections-speciales-overlay">
                <div className="collections-speciales-content">
                  <h3>COLLECTIONS SPÉCIALES</h3>
                  <p>
                    Modèles en édition limitée, pièces rares et collaborations
                  </p>
                  <button>Découvrir la sélection</button>
                </div>
              </div>
            </Link>
          </div>
        </section>

        <div className="best-sellers-container">
          <div className="best-sellers-decoration">❈</div>
          <div className="best-sellers-decoration">❈</div>
          <div className="best-sellers-decoration">✦</div>
          <div className="best-sellers-decoration">✦</div>

          <div className="best-sellers-section">
            <div
              className="section-containers"
              style={{ backgroundColor: "#f3f3e3" }}
            >
              <PopularProducts />
            </div>
          </div>
        </div>

        <section className="features-section">
          <div className="features-container">
            <h2 className="features-title">Nos Garanties</h2>
            <div className="features-grid">
              <div className="feature-card">
                <div className="feature-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                    <circle
                      cx="12"
                      cy="12"
                      r="10"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1"
                      opacity="0.2"
                    />
                  </svg>
                </div>
                <h3 className="feature-title">FABRICATION LOCALE</h3>
                <p className="feature-subtitle">Marque 100% Marocaine</p>
                <p className="feature-description">
                  Artisanat traditionnel marocain
                </p>
              </div>

              <div className="feature-card">
                <div className="feature-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h4c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-5.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z" />
                    <path
                      d="M12 2L2 7l10 5 9-4.5V21h-2V12.5L12 17l-9-4.5V2H2V7l10 5z"
                      opacity="0.3"
                    />
                  </svg>
                </div>
                <h3 className="feature-title">LIVRAISON GRATUITE</h3>
                <p className="feature-subtitle">En 24/48h Partout au Maroc</p>
                <p className="feature-description">
                  Expédition rapide et gratuite
                </p>
              </div>

              <div className="feature-card">
                <div className="feature-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z" />
                    <path d="M6 10h12v2H6z" opacity="0.3" />
                    <path d="M6 14h8v2H6z" opacity="0.3" />
                  </svg>
                </div>
                <h3 className="feature-title">PAIEMENT À LA LIVRAISON</h3>
                <p className="feature-subtitle">Après essayage</p>
                <p className="feature-description">
                  Payez seulement si vous êtes satisfait
                </p>
              </div>

              <div className="feature-card">
                <div className="feature-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z" />
                   
                  </svg>
                </div>
                <h3 className="feature-title">RETOUR ET ÉCHANGE</h3>
                <p className="feature-subtitle">
                  En cas d'erreur ou d'insatisfaction
                </p>
                <p className="feature-description">
                  Service client réactif et flexible
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>

      {showWhatsApp && (
        <a
          href="https://wa.me/212706696865"
          className="whatsapp-float"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="https://cdn-icons-png.flaticon.com/512/220/220236.png"
            alt="WhatsApp"
          />
        </a>
      )}

      <VideoControls />
      <Footer />
    </>
  );
}
